import { SharedCollection } from '@griply/types';
import { collection } from 'firebase/firestore';

import { getDatabase } from './get-database';

export const getCollection = (collectionName: SharedCollection) => {
  return collection(getDatabase(), collectionName);
};
